import { Box, Button, Container, createTheme, ThemeProvider, Typography, useTheme } from "@mui/material";
import MaterialReactTable, { MRT_FullScreenToggleButton } from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { MRT_Localization_ES } from "material-react-table/locales/es";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { getData } from "../../../../services/library";
import Title from "../../../Title";
import NuevoMovimiento from "./NuevoMovimiento";
function MovimientoVehiculo(props) {
  const [historialMovimientos, sethistorialMovimientos] = useState([]);
  const [alta, setAlta] = useState(false)
  const [vehiculo, setVehiculo] = useState(props.datos)
  const [dataVehiculo, setDataVehiculo] = useState()
console.log(vehiculo.idvehiculo);
const getDataVehiculo = () => {
  getData("/vehiculos/xid/" + props.datos.idvehiculo, (res) => {
    if (Array.isArray(res) && res.length > 0) {
      setDataVehiculo(res[0]); // Tomo el primer objeto
    } else {
      setDataVehiculo(null); // Si no hay datos
    }
  });
};

const getMovimientos = () =>{
    getData("/vehiculos_movimientos/historialmovimiento/"+props.datos.idvehiculo, sethistorialMovimientos)
}

console.log(dataVehiculo);

useEffect(() => {
  if (props.datos && props.datos.idvehiculo) {
    setVehiculo(props.datos);
    getMovimientos();
    getDataVehiculo();
  }
}, [props.datos]);


  
  
    const globalTheme = useTheme();
const columns = useMemo(
  () => [
    { header: 'Observaciones', accessorKey: 'observaciones', size: 100 },
    { 
      header: 'Kilometraje Inicial', 
      accessorKey: 'kilometraje_inicial',
      muiTableBodyCellProps: {
        align: "right",
        sx: { textAlign: "right", color: "black", borderColor: "black", },
      },
     size: 50 
    },
    { 
      header: 'Kilometraje Final', 
      accessorKey: 'kilometraje_final',
      muiTableBodyCellProps: {
        align: "right",
        sx: { textAlign: "right", color: "black", borderColor: "black", },
      },
      size: 50,
    },
    { header: 'Fecha', accessorKey: 'fecha_format', type: "date", format: "DD-MM-YYYY", size: 40 },
  ],
  []
);


      const tableTheme = useMemo(
          () =>
              createTheme({
                  palette: {
                      mode: globalTheme.palette.mode,
                      primary: globalTheme.palette.primary, //primary color for the table
                      info: {
                          main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
                      },
                      background: {
                          default:
                              globalTheme.palette.mode === "light"
                                  ? "rgb(234, 239, 241)"
                                  : "#000", //pure black table in dark mode for fun
                      },
                  },
                  typography: {
                      button: {
                          textTransform: "none", //customize typography styles for all buttons in table by default
                          fontSize: "1rem",
                      },
                  },
                  components: {
                      MuiTooltip: {
                          styleOverrides: {
                              tooltip: {
                                  fontSize: "0.8rem", //larger tooltip font size                                
                              },
                          },
                      },
                  },
  
              }), [globalTheme]);
  
      const muiSearchTextFieldProps = {
          placeholder: "Buscar..",
          sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
          variant: "outlined",
          color: "success",
          size: "small",
      };
  
      const initialState = {
          density: "compact",
          showGlobalFilter: true,
          pagination: { pageIndex: 0, pageSize: 10 }
      };
  
    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

const handleClose = () => {
    props.tabla(true);
    props.movimientoVehiculo(false);
  };

  const handleCloseMovimientos = () => {
    setAlta(false)
    getMovimientos()
    getDataVehiculo()
  };

    const handleClickNuevo = () => {
        setAlta(true)
    };
  return (
    <>
    <Container maxWidth="xl">
        <Title titulo={`Movimientos de ${props.datos.patente}`}
        handleClose={handleClose} 
        />
      <Box mt={2} boxShadow={3} mb={3}>
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            enableColumnResizing
            columns={columns}
            data={historialMovimientos}
            // enableRowActions
            initialState={initialState}
            // positionActionsColumn="last"
            muiTableHeadCellProps={tableHeadCellProps}
            localization={MRT_Localization_ES}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "black",
              },
            })}
            enableColumnActions={false}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            layoutMode="grid"
            renderTopToolbarCustomActions={() => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxTwoToneIcon />}
                  onClick={handleClickNuevo}
                >
                  Nuevo Movimiento
                </Button>
              </>
            )}
            renderToolbarInternalActions={({ table }) => (
              <>
                <MRT_FullScreenToggleButton table={table} />
              </>
            )}
          />
        </ThemeProvider>
      </Box>
    </Container>
      {alta && (
        <NuevoMovimiento open={alta} onClose={handleCloseMovimientos} vehiculo={dataVehiculo} />
      )}

      </>

  );
}

export default MovimientoVehiculo;
